
import React from 'react';
import Helper from '../../common/helper';
import clsx from 'clsx';
import { membershipImages, defaultImg } from '../../common/images';
import { 
  Add,
  Selected,
  Check
} from '../../common/icons'



export default function SingleCard({product, selectMembership, couponObj, isUserLogged, locationDataCurrency, languages, locationData,businessCategories}) {
  
  let item                  = product[0];
  let totalAmt              = (parseFloat(item.purchase_price) + parseFloat(item.tax_amt));
  let discountAmt           = (parseFloat(item.purchase_base_price) + parseFloat(item.base_tax_amt)).toLocaleString("en-US");
  let currency              = (item.currency_text) ? item.currency_text : locationDataCurrency;
  let membershipText        = item.item_group_description;
  const component_items     = (item.component_items || item.item_group_components);
  const foc                 = Helper.focLength(component_items);
  const getCoupon           = Helper.checkCoupon(item, couponObj); 
  const PWP                 = Helper.newpwpCheck(item, isUserLogged,locationData, businessCategories);
  const DiscoveryMembership = item.item_group_name.includes('DISCOVERY') ? true : false;
  const ExplorerMembership      = item.item_group_name.includes('EXPLORER') ? true : false;
  const ExplorerPlusMembership  = item.item_group_name && item.item_group_name.includes('EXPLORER PLUS') ? true : false;
  const getVoucherDetails   = Helper.voucherBenefitsChecker(locationData.country);
  const isDBS               = Helper.isDBS(); 
  let   isQbr = item.isQbr ? true : false;
  const itemGroupId         = item.item_group_id;
  const itemGroupName       = item.item_group_name;
  const membershipImage     = membershipImages?.find(img => img.key === itemGroupId)?.membershipImg || defaultImg;
  const qbrImage            = membershipImages[membershipImages.length - 1];
  const isBasePrice         = item.priceLevel?.includes('BASE PRICE');

  let discount = parseFloat(item.purchase_base_price) > parseFloat(item.purchase_price); 

  function getPWPComponent(languageMessage, defaultMessage) {
    return <div className='py-3'>
              <span className='font-montsterrat font-medium total-amount'>{PWP.points}</span> 
              <span className='font-montsterrat font-medium uppercase'> { languageMessage ? languageMessage : defaultMessage}</span>                    
            </div>        
  }
  return (
    <div className={clsx('card flex bg-white desktop:hover:scale-105 duration-500',
    {
        'selected': item.isSelected ? true : false,
    })}key='1'>
    {
        item.isSelected ? <div className='check-holder'><Selected /></div> : ''
    }
        {/* <div className='holder-left-pane md:h-full'
          style={{  
            backgroundImage: `url(${Background})`
          }}
        > */}
          {/* <img src={"assets/product-card-banner.jpg"} /> */}
        {/* </div> */}
        
        <div className='content-holder flex flex-col h-full'>
          <img className="h-auto max-w-full" src={isQbr ? qbrImage : membershipImage} alt={itemGroupName}/>
            <div className='flex flex-col h-full p-5'>
              <div className='holder-title'>
                <h5 className="text-xl tracking-tight text-gray-900 dark:text-white font-montsterrat font-semibold uppercase">
                    {membershipText}
                </h5>
              </div>
                <div className='holder-text'>                                    
                {isUserLogged && !isDBS && (
                  <React.Fragment>
                    {PWP.isPWPExclusive ? (
                      <React.Fragment> 
                        <span>{getPWPComponent(languages.productPwpLoggedInMessage, 'Per Year ALL - Accor Live Limitless Reward points')}</span>
                      </React.Fragment>
                    ) : (
                      <React.Fragment>
                        <div className='py-3'>
                          <span className={clsx('font-montsterrat font-medium', 
                            {
                              'total-amount'    : !discount,
                              'discount-amount' : discount
                            })}>
                            <span>{currency} </span>
                            {totalAmt + ' '} 
                            </span> 
                          <span className='uppercase'> 
                            {discount && (
                              <del>{discountAmt}</del>
                            )}
                            { languages.productYear ? languages.productYear : 'Per Year'}
                          </span>                      
                        </div>
                        {(PWP.exists) && PWP.points && !isQbr && (
                          <React.Fragment>
                          <div className='text-l text-gray-900 dark:text-white font-montsterrat font-semibold'>
                            <span>{ languages.productOr ? languages.productOr : 'OR'}</span>
                          </div>                
                          <span>{getPWPComponent(languages.productPwpLoggedInMessage, 'Per Year ALL - Accor Live Limitless Reward points')}</span>
                        </React.Fragment>
                        )}
                      </React.Fragment>
                    )}
                  </React.Fragment>
                )}
                {
                  isUserLogged && isDBS.status && (
                    <div className='py-3'>
                      <span className={`font-montsterrat font-medium ${discount && !getCoupon.exists ? 'discount-amount' : 'total-amount'}`}>
                      <span></span>{getCoupon.exists ? getCoupon.total + ' ' + currency + ' (coupon applied)' : totalAmt + ' '}
                      </span>
                      <span className='uppercase'>
                        {discount && !getCoupon.exists && (
                          <del>{discountAmt}</del>
                        )}
                          {getCoupon.exists ? '' : ' Per Year '}</span>                      
                    </div>
                  )
                }
                
                  {!isUserLogged && !PWP.isPWPExclusive && (
                    <div className='py-3'>
                      <span className={`font-montsterrat font-medium ${discount && !getCoupon.exists ? 'discount-amount' : 'total-amount'}`}>
                      <span>{getCoupon.exists ? '' : currency} </span>{getCoupon.exists ? getCoupon.total + ' ' + currency + ' (coupon applied)' : totalAmt + ' '}
                      </span>
                      <span className='uppercase'>
                        {discount && !getCoupon.exists && (
                          <del>{discountAmt}</del>
                        )}
                          {getCoupon.exists ? '' : + ' ' + languages.productYear ? languages.productYear : 'Per Year'}</span>                      
                    </div>
                  )}                  
                  {!isUserLogged && (
                    <React.Fragment>              
                    {(PWP.exists) && PWP.points && !isQbr && (
                        <React.Fragment>
                          <div className='text-l text-gray-900 dark:text-white font-montsterrat font-semibold'>
                            {
                              !PWP.isPWPExclusive && (
                                <span>{ languages.productOr ? languages.productOr : 'OR'}</span>
                              )
                            }
                          </div>                          
                          <span>{getPWPComponent(languages.productPwpLoggedOutMessage, 'Per Year ALL - Accor Live Limitless Reward points')}</span>
                        </React.Fragment>
                      )}
                    </React.Fragment>
                  )}
                  {isQbr && (
                    <>
                      <div className="py-3">
                        <p className='font-montsterrat font-bold'>Earn {item.qbrPoints} Qantas Points with Qantas Business Rewards*</p>
                      </div>
                      {languages.qbrRewardPoints && (
                        <div className="py-3">
                          <p className='font-montsterrat font-bold'>{languages.qbrRewardPoints} {languages.qbrRewardPointsMessage}</p>
                        </div>
                      )}
                    </>
                  )} 
                  <div className="py-3">
                    <p className='font-montsterrat font-bold'>{languages.enjoyBenefits ? languages.enjoyBenefits : 'ENJOY ACCOR PLUS UNIVERSAL BENEFITS'}</p>
                  </div>
              </div>
              <ul className='membership-inclusions mb-5'> 
                {DiscoveryMembership && (
                  <React.Fragment>
                    {languages.discoveryMembershipCustomMessageList1 ? (
                      <li className='inclusion-list flex items-center'>
                        <div className='list-icon-holder'>
                            <Add />
                        </div>
                        <span className='list-desc text-lg'>{languages.discoveryMembershipCustomMessageList1 ? languages.discoveryMembershipCustomMessageList1 : 'Earn 1,000 Discovery Dollars'}</span>
                      </li>
                    ) : <></>}

                    {languages.discoveryMembershipCustomMessageList2 ? (
                      <li className='inclusion-list flex items-center'>
                        <div className='list-icon-holder'>
                            <Add />
                        </div>
                        <span className='list-desc text-lg'>{languages.discoveryMembershipCustomMessageList2 ? languages.discoveryMembershipCustomMessageList2 : '10% savings on membership(RRP $498)'}</span>
                      </li>
                    ) : <></>}                   
                    
                    <li className='inclusion-list flex items-center'>
                      <div className='list-icon-holder'>
                          <Add />
                      </div>
                      <span className='list-desc text-lg'>{languages.discoveryMembershipMessage ? languages.discoveryMembershipMessage : 'Amazing cruise, tour and wine offers worldwide'}</span>
                    </li>
                  </React.Fragment>
                )}          
                {foc != 0  && (
                  <li className='inclusion-list flex items-center'>
                      <div className='list-icon-holder '>
                        <Add />
                      </div>
                      <span className='list-desc text-lg'>
                      {
                        item.component_description ? (
                          <span>{item.component_description}</span>
                        ) : (
                          <span>
                            {foc > 1 ?
                              foc + languages.productFocAvailableMultipleMessage ? languages.productFocAvailableMultipleMessage : " Stay Plus complimentary nights"
                              :
                              foc + languages.productFocAvailableSingleMessage ? languages.productFocAvailableSingleMessage : " Stay Plus complimentary night"
                            }
                          </span>
                        )
                      }                
                      </span>
                  </li>
                )}
                {
                  ExplorerMembership && isBasePrice && !ExplorerPlusMembership && !isQbr && languages.productBonusRewardPoints ? (
                    <li className='inclusion-list flex items-center'>
                      <div className='list-icon-holder'>
                          <Add />
                      </div>
                      <span className='list-desc text-lg'>{languages.productBonusRewardPoints ? languages.productBonusRewardPoints : 'Bonus 2,000 Reward Points (For a limited time)'}</span>
                    </li>
                  ) : <></>  
                }
                {
                  DiscoveryMembership && getVoucherDetails[1].discovery &&
                  <li className='inclusion-list flex items-center'>
                    <div className='list-icon-holder'>
                        <Add />
                    </div>
                      <span className='list-desc text-lg'>
                      {languages.productVoucherBenefitsDiscovery ? languages.productVoucherBenefitsDiscovery : " Exclusive dining and accommodation discount vouchers"}
                      </span>
                  </li>
                }
                {
                  ExplorerMembership && getVoucherDetails[0].explorer &&
                  <li className='inclusion-list flex items-center'>
                    <div className='list-icon-holder'>
                        <Add />
                    </div>
                      <span className='list-desc text-lg'>
                      {languages.productVoucherBenefitsExplorer ? languages.productVoucherBenefitsExplorer : " Exclusive dining and accommodation discount vouchers"}
                      </span>
                  </li>
                } 
                {/*Helper.isQbr(locationData) && (
                    <li className='inclusion-list flex items-center'>
                    <div className='list-icon-holder'>
                      <Add />
                    </div>
                    <span className='list-desc text-lg'>Gold membership status in ALL – Accor Live Limitless</span>
                </li>
                )*/}  
              </ul>
              <div className='holder-button w-full flex align-center'>
                <button 
                    className={clsx('btn rounded uppercase font-montsterrat font-normal',
                    {
                      'single-btn-outline-blue': !item.isSelected,
                      'btn-added': item.isSelected
                    }
                    )}  
                    type='button' 
                    onClick={() => selectMembership(item)}>
                    {
                      // Static
                      item.isSelected ? 
                      <span className='flex items-center justify-center'>
                          <span className='flex items-center justify-center mr-2'><Check /></span>   
                          {languages.added ? languages.added : 'Added'}
                      </span> :
                      <span>{languages.select ? languages.select : 'Select'}</span> 
                    }                                
                </button>
              </div>
            </div>
        </div>
    </div>
  )
}

